<template>
  <div class="flex h-2 mb-4 overflow-hidden text-xs bg-indigo-200 rounded">
    <div :style="progressStyle" class="flex flex-col justify-center text-center text-white bg-indigo-500 shadow-none whitespace-nowrap"></div>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },

  computed: {
    progressStyle() {
      return {
        width: this.progressPc + '%',
      }
    },

    progressPc() {
      return Math.round(this.progress * 100)
    },
  },
}
</script>
